import React, { Component } from "react";
import { Divider, Icon, Grid, Container, List } from "semantic-ui-react";
import { Link } from "react-router-dom";
import "./footer.css";

import {
  CLUBS_ROUTE,
  PRIVACY_POLICY_ROUTE,
  TERMS_CONDITIONS_ROUTE,
  CONTACT_ROUTE,
  FACKBOOK_LINK,
  TWITTER_LINK,
  INSTAGRAM_LINK
} from "../../constants/route.constants";

export default class Footer extends Component {
  render() {
    const year = new Date().getFullYear();
    return (
      <footer>
        <Container>
          <Grid padded stackable={true}>
            <Grid.Row className="footer__clubs-menu">
              <Grid.Column width={2}>
                <h4>Africa</h4>
                <List link>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/south-africa`}>South Africa</Link>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Asia</h4>
                <List link>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/bahrain`}>Bahrain</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/cambodia`}>Cambodia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/china`}>China</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/india`}>India</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/indonesia`}>Indonesia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/japan`}>Japan</Link>
                  </List.Item>

                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/kuwait`}>Kuwait</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/malaysia`}>Malaysia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/myanmar`}>Myanmar</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/oman`}>Oman</Link>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={2}>
                <div className="header-spacer" />
                <List link>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/phillipines`}>Phillipines</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/qatar`}>Qatar</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/saudi-arabia`}>Saudi Arabia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/singapore`}>Singapore</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/south-korea`}>South Korea</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/taiwan`}>Taiwan</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/thailand`}>Thailand</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/united-arab-emirates`}>
                      U.A.E
                    </Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/vietnam`}>Vietnam</Link>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Australasia</h4>
                <List link>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/australia`}>Australia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/new-zealand`}>New Zealand</Link>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={2}>
                <h4>Europe</h4>
                <List link>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/austria`}>Austria</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/belgium`}>Belgium</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/czech-republic`}>
                      Czech Republic
                    </Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/denmark`}>Denmark</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/england`}>England</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/estonia`}>Estonia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/finland`}>Finland</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/france`}>France</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/germany`}>Germany</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/italy`}>Italy</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/jersey`}>Jersey</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/luxembourg`}>Luxembourg</Link>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={2}>
                <div className="header-spacer" />
                <List link>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/netherlands`}>Netherlands</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/norway`}>Norway</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/poland`}>Poland</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/portugal`}>Portugal</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/romania`}>Romania</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/russia`}>Russia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/scotland`}>Scotland</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/slovakia`}>Slovakia</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/spain`}>Spain</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/sweden`}>Sweden</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/switzerland`}>Switzerland</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/wales`}>Wales</Link>
                  </List.Item>
                </List>
              </Grid.Column>
              <Grid.Column width={3}>
                <h4>North/South America</h4>
                <List link>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/america`}>America</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/argentina`}>Argentina</Link>
                  </List.Item>
                  <List.Item>
                    <Link to={`${CLUBS_ROUTE}/canada`}>Canada</Link>
                  </List.Item>
                </List>
              </Grid.Column>
            </Grid.Row>
            <Divider />
            <Grid.Row>
              <Grid.Column width={6}>
                <span>Copyright &copy; {year} All Rights Reserved.</span>
              </Grid.Column>
              <Grid.Column width={7}>
                <Link to={PRIVACY_POLICY_ROUTE}>Privacy Policy</Link>
                <span className="sep">|</span>
                <Link to={TERMS_CONDITIONS_ROUTE}>Terms & Conditions</Link>
                <span className="sep">|</span>
                <Link to={CONTACT_ROUTE}>Contact Us</Link>
              </Grid.Column>
              <Grid.Column width={3} textAlign="right">
                <a
                  target="_blank"
                  href={FACKBOOK_LINK}
                  rel="noopener noreferrer"
                >
                  <Icon name="facebook f" size="large" />
                </a>
                <a
                  target="_blank"
                  href={TWITTER_LINK}
                  rel="noopener noreferrer"
                >
                  <Icon name="twitter" size="large" />
                </a>
                <a
                  target="_blank"
                  href={INSTAGRAM_LINK}
                  rel="noopener noreferrer"
                >
                  <Icon name="instagram" size="large" />
                </a>
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </Container>
      </footer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Footer/FooterView.js